import type { Theme } from '@mui/material';
import { useMediaQuery } from '@mui/material';

export const useSplitPane = () =>
  useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'));
